const IconArrow = () => (
    <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 5L6.5 1.5 8 0l6 6-6 6-1.5-1.5L10 7H0V5h10z"
            fillRule="evenodd"
            fillOpacity=".7"
        />
    </svg>
);

export default IconArrow;
